export const games = {
  titleBreakingLeague: "BREAKING THE LEAGUE",
  titleBreakingLeagueMobile: "💥 BREAKING THE LEAGUE",
  gamesSubTitle: "They don't want to leave anything for anyone.",
  recentTitle: "THE MOST RECENT",
  recentTitleMobile: "📢 THE MOST RECENT",
  recentSubTitle: "Try your luck with our new games",
  newLabel: "NEW",
  top10GamesTitle: "TOP",
  top10GamesTitle2: "GAMES",
  top10GamesSubTitleDesktop: "SEE THE MOST PLAYED GAMES IN VENEZUELA",
  top10GamesSubTitleMobile: "🇻🇪 The <highlight>10</highlight> most played in all of Venezuela 🇻🇪",
  randomTitle: "Can't decide?",
  randomTitleMobile: "🍀 Let luck decide!",
  randomDescription:
    "Hit play and let luck choose your next winning game. 🎯 Pick a category, press the button... and let luck begin!",
  randomDescriptionMobile: "Hit play and let luck choose your next winning game.",
  selectCategory: "Choose a category",
  randomPlayButton: "Let's play!",
  randomQuestion: "Which will be the next game to bring you luck? 🍀",
  randomButton: "Go to game 🚀",
  topPayingGamesTitle: "TOP PAYING GAMES",
  topPayingGamesSubTitle: "They're dropping money",
  recentlyPlayedTitle: "KEEP PLAYING",
  recentlyPlayedSubTitle: "Pick up where you left off",
  lotteryGamesTitle: "LOTTERY GAMES",
  lotteryGamesSubTitle: "Try your luck with our lottery games",
  allGamesTitle: "ALL GAMES",
  dontMiss: "DON'T MISS IT",
  dontMissTournaments: "Tournaments, free spins, promos and more.",
  tournamentRules: "Rules",
  // Multi-Game Floating Button translations
  multiGameFloatingButton: "Quick Games",
  quickGamesTitle: "Quick Games",
  quickGamesDescription: "Keep playing while waiting for your main game!",
  hideQuickGames: "Hide",
  minimizeQuickGames: "Minimize",
  playNow: "Play Now",
  noQuickGamesAvailable: "No games available at the moment",
  unknownGame: "Unknown Game",
  unknownProvider: "Unknown",
  loadingGames: "Loading games...",
};
